import * as React from "react";

import "./flex-number-input.scss";

import {cs}                  from "@Common/react/chain-services";
import {NumberInputBinding2} from "@Common/react/number-input-binding-2";
import {OnMounted}           from "@Common/react/on-mounted";
import {Static2}             from "@Common/react/static-2";
import {UseState}            from "@Common/react/use-state";

/**
 * Normally display as a static text, with an edit icon beside.
 * Once clicked, it becomes input with check and close icons
 */
export const FlexNumberInput = ({value, onChange}) => cs(
    ["editing", (_, next) => UseState({next})],
    ({editing}) => (
        <div className="flex-number-input flex-number-input-91o">
            {!editing.value ? <>
                <div className="text">
                    {value}
                </div>
                <div className="controls">
                    <i
                        className="fa fa-pencil"
                        onClick={() => editing.onChange(true)}
                    />
                </div>
            </> : cs(
                ["saving", (_, next) => UseState({next})],
                ["attemptSave", ({saving}, next) => next(async (v) => {
                    saving.onChange(true);
                    try {
                        await onChange(v);
                        editing.onChange(false);
                    } finally {
                        saving.onChange(false);
                    }
                })],
                ["binding", ({saving, attemptSave}, next) => NumberInputBinding2({
                    value,
                    onSave: attemptSave,
                    onCancel: () => editing.onChange(false),
                    next,
                })],
                ["ref", (_, next) => Static2({next})],
                ({binding, saving, attemptSave, ref}) => <>
                    <input {...{
                        ...binding.handle,
                        onBlur: undefined,
                        disabled: saving.value,
                        ref: ref.set,
                    }}/>
                    {OnMounted({
                        action: () => ref.get().select(),
                    })}
                    <div className="controls">
                        {!saving.value ? (
                            <i
                                className="fa fa-check"
                                onClick={() => !binding.hasError && (
                                    binding.changed ? (
                                        attemptSave(binding.getValue())
                                    ) : (
                                        editing.onChange(false)
                                    )
                                )}
                            />
                        ) : (
                            <i
                                className="fa fa-spinner fa-pulse"
                                // onClick={() => editing.onChange(false)}
                            />
                        )}
                        <i
                            className="fa fa-close"
                            onClick={() => editing.onChange(false)}
                        />
                    </div>
                </>,
            )}
        </div>
    ),
);
